export const serverUrl = "/server";

// export const serverUrl = "http://localhost:5000";
